module.exports = __webpack_public_path__ + "static/img/2025年历-3.a9a425c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-3.png
// module id = dte/
// module chunks = 3